// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
import "@hotwired/turbo-rails";
import "../controllers/index.js";
// Use Turbo's built-in scroll restoration with custom fix
import { Turbo } from "@hotwired/turbo-rails";
Turbo.setConfirmMethod(() => true); // Always confirm navigation

// Import scroll restoration fix for Turbo issues
import "../scroll-restoration-fix.js";

import RailsUJS from "@rails/ujs";
RailsUJS.start();
window.$ = $; // For RailsUJS / .js.erb files


import { addGclid } from "../gclid.js";

// Lazy load jQuery plugins
const loadAutoGrow = () => import("../jquery.autogrow-textarea.js");
const loadSmartResize = () => import("../jquery.smartresize.js");
import "../jquery.fixedtableheader-1.0.4";
const loadSimpleSlideshow = () => import("../jquery.simpleslideshow.js");
import "../squeezetext";
import "../charts.js";

// Page-specific requires
import "../outlines.js";
import "../news_articles.js";

import DataTable from "datatables.net-dt";
import "../jquery.datatables.sorting.frequency";

import searchBar from "../search";
import { init as resizeTableInit, resize as resizeTable } from "../table-resize";

// Make resize functions available globally for AJAX tables
window.resizeTableInit = resizeTableInit;
window.resizeTable = resizeTable;
import setHousingThumbnails from "../housing-thumbnail";
import {
  scrollToLastPosition as buttonNavScrollToLastPosition,
  attachListeners as buttonNavAttachListeners,
} from "../button-navigation-scroll-lock";
import onResize from "../onResize";
import housingImages from "../get-housing-image-list";

function printPDF(url) {
  var iframe = this._printIframe;
  if (!this._printIframe) {
    iframe = this._printIframe = document.createElement("iframe");
    document.body.appendChild(iframe);

    iframe.style.display = "none";
    iframe.onload = function () {
      setTimeout(function () {
        iframe.focus();
        iframe.contentWindow.print();
      }, 1);
    };
  }

  iframe.src = url;
}

function setStickyHorizontalNav(start_width) {
  var stickyNav = $("#horz_nav.sticky");
  if (stickyNav.html().length > 0) return;

  $("#horz_nav.sticky").html($("#horz_nav").html());

  // Cache header height to avoid repeated DOM queries
  var headerHeight = $("header").height() + 5;
  var windowWidth = $(window).width();

  var belowHeader = function () {
    return $(window).scrollTop() > headerHeight && windowWidth > start_width;
  };

  if (belowHeader()) {
    stickyNav.css("display", "block");
  }

  // Throttle scroll events to prevent excessive reflows
  var scrollTimer = null;
  $(window).on("scroll.stickyNav", function () {
    if (!scrollTimer) {
      scrollTimer = requestAnimationFrame(function () {
        var $nav = $("#horz_nav.sticky");
        if ($(window).scrollTop() > headerHeight && windowWidth > start_width) {
          $nav.css("display", "block");
        } else {
          $nav.css("display", "none");
        }
        scrollTimer = null;
      });
    }
  });
}

function shuffle(array) {
  var i = 0,
    j = 0,
    temp = null;

  for (i = array.length - 1; i > 0; i -= 1) {
    j = Math.floor(Math.random() * (i + 1));
    temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}

function setHousingCarousel() {
  // Defer carousel setup to avoid blocking initial render
  requestAnimationFrame(() => {
    // Clear any existing carousel content
    $("#carousel").empty();
    
    // Batch DOM reads
    var headlineHeight = $(".section_header .section_headline").outerHeight() || 0;
    var summaryHeight = $(".page_summary").outerHeight() || 0;
    var section_height = headlineHeight + summaryHeight + 50;
    section_height = section_height < 180 ? section_height + "px" : "180px";

    // Get images from either cards or table
    var imageList = housingImages();
    
    // If no images available yet, try again later when table loads
    if (imageList.length === 0) {
      // Listen for turbo frame loading and retry
      document.addEventListener('turbo:frame-load', function retryCarousel() {
        // Remove this listener after first use
        document.removeEventListener('turbo:frame-load', retryCarousel);
        // Retry carousel setup
        setHousingCarousel();
      });
      return;
    }

    // Batch DOM writes
    $("#carousel_wrapper").prepend("<style>#carousel img { height: " + section_height + "; }</style>");
    var images = imageList.map(function (path) {
      return '<img src="' + path + '" alt="" height="180" width="180"/>';
    });
    shuffle(images);
    var firstImage = $('<div class="current-slide">' + images.shift() + "</div>");
    $("#carousel").append(firstImage);

    if (images.length) {
      loadSimpleSlideshow().then(() => {
        $("#carousel").simpleSlideshow({
          slideshowData: images,
          slidePauseSpeed: 3500, // the amount of time (in ms) to show the slide for
          paging: false, // show paging controls
        });
      });
    }
  });
}

// Fix for turbolinks anchor tag bug
const linkTargetsAnchorOnSamePage = function (link) {
  const href = link.getAttribute("href");

  if (href.charAt(0) === "#") {
    return true;
  }

  if (href.match(new RegExp("^" + window.location.toString().replace(/#.*/, "") + "#"))) {
    return true;
  } else if (href.match(new RegExp("^" + window.location.pathname + "#"))) {
    return true;
  }

  return false;
};
$(document).on("turbo:click", function (event) {
  if (linkTargetsAnchorOnSamePage(event.target)) {
    return event.preventDefault();
  }
});

function setFixedTableHeader(isResize = false) {
  // Store current visibility state of headers before removing
  const headerVisibility = {};
  $("[id^='fixedtableheader']").each(function() {
    headerVisibility[this.id] = $(this).is(':visible');
  });

  // First remove ALL existing fixed headers to prevent duplicates
  $("[id^='fixedtableheader']").each(function() {
    $(window).off("scroll." + this.id);
    $(window).off("resize." + this.id);
    $(this).remove();
  });

  // Reset any data attributes on tables
  $(".productTable").removeData('hasFixedHeader');

  // Now create fresh headers for visible tables only
  $(".productTable:visible").each(function (index) {
    const $table = $(this);
    
    // Generate a truly unique ID using timestamp + index
    const uniqueId = `${Date.now()}_${index}`;
    
    // Call the plugin on just this table
    $table.fixedtableheader({
      headerrowsize: $table.find("tr").has("th").length,
      highlightrow: true,
      highlightclass: "ruled",
      tableNumber: uniqueId,  // This will create fixedtableheader + uniqueId
    });
    
    // Mark as processed
    $table.data('hasFixedHeader', true);
  });
  
  // If this is a resize and headers were visible, trigger scroll to show them
  if (isResize && Object.values(headerVisibility).some(v => v)) {
    $(window).trigger('scroll');
  }
}

// Make setFixedTableHeader available globally for Stimulus controllers
window.setFixedTableHeader = setFixedTableHeader;

var tables = [];

// Store the frame load handler so we can clean it up
var frameLoadHandler = null;

// Clean up DataTables before rendering new content
document.addEventListener("turbo:before-render", function () {
  // Destroy all DataTable instances (still needed for initial page load tables)
  if (tables.length > 0) {
    tables.forEach(function(table) {
      if (table && $.fn.DataTable.isDataTable(table.table().node())) {
        table.destroy();
      }
    });
    tables = [];
  }
  
  // Clear DataTable search extensions
  $.fn.dataTable.ext.search = [];
  
  // Remove fixed table headers and unbind their scroll events
  $("[id^='fixedtableheader']").each(function() {
    const fixedID = "#" + this.id;
    $(window).off("scroll." + fixedID.replace('#', ''));
    $(this).remove();
  });
  
  // Remove the frame load handler to prevent accumulation
  if (frameLoadHandler) {
    document.removeEventListener('turbo:frame-load', frameLoadHandler);
  }
});

document.addEventListener("turbo:before-cache", function () {
  $("[id^='fixedtableheader']").remove();
  $(".cartContents").remove();
  $("#housing_thumbnail").remove();
  $("#carousel").empty();
  if (tables.length > 0) {
    tables.forEach(function(table) {
      if (table && $.fn.DataTable.isDataTable(table.table().node())) {
        table.destroy();
      }
    });
    tables = [];
  }
  
  // Remove Cookie-Script elements before caching to prevent issues
  const cookieScriptElements = document.querySelectorAll(
    '[id^="cookiescript_"], ' +
    '.cookiescript-wrapper, ' +
    '#cookiescript_injected, ' +
    '[class*="cookiescript"], ' +
    '[data-cookiescript], ' +
    'style[data-cookiescript-stylesheet]'
  );
  cookieScriptElements.forEach(el => el.remove());
  
  // Also remove any inline scripts added by Cookie-Script
  const inlineScripts = document.querySelectorAll('script:not([src])');
  inlineScripts.forEach(script => {
    if (script.innerHTML.includes('cookiescript') || script.innerHTML.includes('CookieScript')) {
      script.remove();
    }
  });
});

document.addEventListener("turbo:render", function () {
  // Disabled manual scroll restoration to let Turbo handle it natively
  // buttonNavScrollToLastPosition();
});

// Additional event to handle Cookie-Script after Turbo renders new content
document.addEventListener("turbo:frame-render", function () {
  // Re-trigger cookie script initialization for frame updates
  if (window.CookieScript && window.CookieScript.init) {
    window.CookieScript.init();
  }
});

// Listen for when Turbo is about to visit a new page
document.addEventListener("turbo:before-visit", function () {
  // Clean up Cookie-Script before navigation
  const cookieElements = document.querySelectorAll(
    '[id*="cookiescript"], [class*="cookiescript"], [data-cookiescript]'
  );
  cookieElements.forEach(el => {
    if (!el.hasAttribute('data-turbo-permanent')) {
      el.remove();
    }
  });
});

// Track if this is the first page load
let cookieScriptInitialized = false;

// Re-fire Google Tag Manager on Turbo navigation
document.addEventListener("turbo:load", function () {
  // Fire GTM page view event for cookie banner and other GTM scripts
  if (typeof window.dataLayer !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      'event': 'turbo:load',
      'turbo.url': window.location.href,
      'turbo.path': window.location.pathname
    });
    
    // Also fire a virtual pageview for GTM
    window.dataLayer.push({
      'event': 'virtualPageview',
      'page': {
        'url': window.location.href,
        'path': window.location.pathname,
        'title': document.title
      }
    });
  }
  
  // Handle Cookie-Script re-initialization after first load
  if (cookieScriptInitialized) {
    // Option 1: If Cookie-Script is loaded via GTM, force GTM to re-evaluate
    if (window.google_tag_manager) {
      // Clear any Cookie-Script related data
      if (window.CookieScript) {
        delete window.CookieScript;
      }
      
      // Force GTM to reload all tags
      window.dataLayer.push({
        'event': 'gtm.init',
        'gtm.uniqueEventId': Date.now()
      });
    }
    
    // Option 2: Manually trigger Cookie-Script initialization if it exists
    setTimeout(() => {
      // Check if Cookie-Script has been loaded by GTM
      if (window.CookieScriptDebug) {
        window.CookieScriptDebug.init();
      } else if (window.CookieScript && window.CookieScript.init) {
        window.CookieScript.init();
      }
    }, 100);
  }
  
  cookieScriptInitialized = true;
  
  addGclid();

  // Batch DOM reads
  var measurements = {
    mobile_width: 769,
    isProductPage: $("#product_page").length > 0,
    isRFQPage: $("#rfq_page").length > 0,
    windowWidth: $(window).width(),
  };

  if (measurements.isRFQPage) {
    loadAutoGrow().then(() => {
      $("#quote_request_item_note").autogrow();
    });
    $(".notice_box").hide().slideDown(700);
  }

  // Function to initialize DataTables
  function initializeProductTables() {
    var freqMaxColumnList = {
        "/products/hybrids/hybrids": 2,
        "/products/hybrids/90deg_21-41": 2,
        "/products/hybrids/90deg_21-41_stripline": 2,
        "/products/hybrids/90deg_51-1251": 2,
      };
      var freqMaxColumn = 1;
      if (window.location.pathname in freqMaxColumnList) {
        freqMaxColumn = freqMaxColumnList[window.location.pathname];
      }

    // Initialize each table individually to avoid timing issues
    $(".productTable").each(function(tableIndex) {
      var $tableElement = $(this);
      
      // Skip if DataTable already initialized on this table
      if ($.fn.DataTable.isDataTable($tableElement[0])) {
        return;
      }
      
      var wrapper = $tableElement.closest('.productTableWrapper');
      var filters = wrapper.find('.product-filters');
      
      // Initialize DataTable for this specific table
      var table = $tableElement.DataTable({
        paging: false,
        order: [[freqMaxColumn, "asc"]],
        searching: true,
        dom: 'rtip', // Remove default search box since we have custom filters
        autoWidth: false,
        columnDefs: [
          {
            type: "frequency",
            targets: [freqMaxColumn - 1, freqMaxColumn],
          },
        ],
        infoCallback: function (settings, start, end, max, total, pre) {
              var info = "Showing " + end + " matches (filtered from " + max + " total)";
              if (end != max) {
                return info;
              }
        },
        fnDrawCallback: function (settings, json) {
          // Don't call setFixedTableHeader here - let the view toggle controller handle it
        }
      });
      
      // Store table instance for cleanup
      tables.push(table);
      
    });
  }

  if (!measurements.isProductPage) {
    // Initialize tables on page load
    initializeProductTables();
    
    // Initialize table resize for all viewports
    console.log(`Viewport ${measurements.windowWidth}px - enabling table resize`);
    resizeTableInit(".productTable", 954);
    resizeTable();
    // Don't call setFixedTableHeader here - let the view toggle controller handle it
    // Also remove any accidentally created headers on page load
    $("[id^='fixedtableheader']").remove();
    
    // Re-initialize DataTables when tables are loaded via Turbo Frames
    frameLoadHandler = function(event) {
      // Check if the loaded frame contains product tables
      const loadedFrame = event.target;
      const productTables = loadedFrame.querySelectorAll('.productTable');
      
      if (productTables.length > 0) {
        console.log('Turbo Frame loaded with product tables, re-initializing DataTables');
        // Turbo frame content is ready immediately after turbo:frame-load
        initializeProductTables();
        resizeTableInit(".productTable", 954);
        resizeTable();
        // Don't call setFixedTableHeader here - let the view toggle controller handle it
      }
    };
    document.addEventListener('turbo:frame-load', frameLoadHandler);

      // Dynamically Resize Table
      // window.lastWidth check is for an iOS 10 bug that triggers resize on scroll
      window.lastWidth = null;
      // Debounce resize handler to prevent excessive updates
      let resizeTimeout;
      
      $(window).on("resize", function () {
        var currentWidth = $(window).width();
        if (window.lastWidth != currentWidth) {
          // Clear previous timeout
          clearTimeout(resizeTimeout);
          
          // Add class to hide headers during resize
          $('body').addClass('header-updating');
          
          // Debounce the actual resize operations
          resizeTimeout = setTimeout(() => {
            console.log(`Window resized to ${currentWidth}px - calling resizeTable`);
            // Re-initialize resize for all tables (including AJAX-loaded ones)
            resizeTableInit(".productTable", 954);
            resizeTable();
            
            // Only update fixed headers if tables are visible (in table view)
            if ($(".productTable:visible").length > 0 && $("[id^='fixedtableheader']").length > 0) {
              setFixedTableHeader(true); // Pass true to indicate this is a resize
            }
            
            // Remove hiding class after a short delay
            setTimeout(() => {
              $('body').removeClass('header-updating');
            }, 50);
            
            window.lastWidth = currentWidth;
          }, 150); // 150ms debounce delay
        }
      });
  }

  setStickyHorizontalNav(measurements.mobile_width);
  searchBar();
  buttonNavAttachListeners();

    // Prelim code for fixing responsive multirow/col headers
    // https://github.com/DataTables/Responsive/issues/71
    // table.on('responsive-resize', function(e, datatable, columns) {
    //   columns.forEach(function(is_visible, index) {
    //     $.each($('tr', datatable.table().header()), function() {
    //       var col = $($(this).children()[index]);
    //       is_visible == true ? col.show() : col.hide();
    //     });
    //   });
    // });

    // if (!isProductPage) {
    // Add fixed table header
    // $('.productTable').each(function(i) {
    // $(this).DataTable();
    // $(this).fixedtableheader({
    //   headerrowsize: $(this)
    //     .find('tr')
    //     .has('th').length,
    //   highlightrow: true,
    //   highlightclass: 'ruled',
    //   heightoffset: 45,
    //   tableNumber: i,
    // });
    // });

    // Dynamically Resize Table
    // resizeTable('.productTable', 695);
    // $(window).smartresize(function() {
    //   resizeTable('.productTable', 695);
    //   $('table[id^=fixedtableheader]').css('width', $('.productTable').width() + 2);
    // });
    // }

  if (measurements.isProductPage) {
    if (measurements.windowWidth <= measurements.mobile_width) {
      // Open pdf in same window for mobile devices.
      if ($("a.pdf").attr("target")) {
        $("a.pdf").attr("target", "");
      }
    }
  }

  var elements = document.querySelectorAll("main h2:first-of-type, .section_headline");
  window.squeezeText.elements = [];
  window.squeezeText(elements);

  // Load Chart.js only when actually needed (product pages with charts)
  var productPage = window.location.pathname.split("/")[1] == "product";
  if (productPage && $("#performance").length) {
    // Only load if we're on a product page AND the performance section exists
    import("chart.js/auto").then((ChartJS) => {
      window.Chart = ChartJS.default;
      // Initialize charts after Chart.js is loaded
      if (typeof window.get_charts === "function") {
        window.get_charts();
      }
    });
  }

  if (measurements.windowWidth > measurements.mobile_width) {
    setHousingCarousel();
    setHousingThumbnails();
  }
});
